export default {"gitHash":"9062fdac37f99a341ccf458a4fb92fed7cce9e3b","gitHashShort":"9062fda","time":1675229924502,"platform":"linux","arch":"x64"};